export default "__VITE_ASSET__b6139929__"